import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/';

import Create from "./Create.js"
import Edit from "./Edit.js"
import Delete from "./Delete.js"
import Detail from "./Detail.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"



class Pais extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create:true,
                        permission: 'pais_add',
                        component: Create,
                    },
                    {
                        detail: true,
                        permission: 'pais_detail',
                        component: Detail,
                    },
                    {
                        edit:true,
                        permission: 'pais_edit',
                        component: Edit,
                    },
                    {
                        edit:true,
                        permission: 'pais_delete',
                        component: Delete,
                    }
                ]}

                apiUrl={api.misc.paises.list}
                columns={this.state.columns}
                exportUrl={api.misc.paises.export}
                title={"Países"}
                outerSort={[{"id":"nombre","desc":false}]}
            />
        );
    }
}

export default Pais;



// WEBPACK FOOTER //
// ./src/views/misc/Pais/Pais.js